<div class="adb-empty" [class.adb-empty--compact]="compact" data-testid="adb-empty">
  <i class="adb-empty__icon {{ icon }}" aria-hidden="true" data-testid="adb-empty-icon"></i>
  <p *ngIf="title" class="adb-empty__title" data-testid="adb-empty-title">{{ title }}</p>
  <p *ngIf="body" class="adb-empty__body" data-testid="adb-empty-body">{{ body }}</p>
  <ng-content></ng-content>
</div>
